import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Loans from "./pages/Loans";
import Layout from "./components/Layout";
import LoanReservations from "./pages/LoanReservations";
import LoanFeeReceipt from "./pages/LoanFeeReceipt";
import LoanPayments from "./pages/LoanPayments";
import LoanHistory from "./pages/LoanHistory";
import Installments from "./pages/Installments";
import Expenses from "./pages/Expenses";
import Investments from "./pages/Investments";
import WeeklyPenalties from "./pages/WeeklyPenalties";
import Balance from "./pages/Balance";

const ProtectedRoute = ({
  children,
  requiredPage,
}: {
  children: React.ReactNode;
  requiredPage?: string;
}) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPage && user.role !== "admin") {
    const investorAllowedPages = [
      "dashboard",
      "investments",
      "weekly-penalties",
      "balance",
      "installments",
      "loans",
      "loan-reservations",
      "loan-fee-receipt",
      "loan-payments",
      "loan-history",
      "expenses",
    ];
    const isInvestorAllowed =
      user.role === "investor" && investorAllowedPages.includes(requiredPage);
    const hasAccess =
      isInvestorAllowed ||
      (user.permissions && user.permissions.includes(requiredPage));
    if (!hasAccess) {
      return (
        <Layout>
          <div className="flex items-center justify-center h-[50vh]">
            <div className="text-center space-y-4">
              <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-200">
                عدم دسترسی
              </h2>
              <p className="text-slate-600 dark:text-slate-400">
                شما مجوز لازم برای مشاهده این صفحه را ندارید.
              </p>
            </div>
          </div>
        </Layout>
      );
    }
  }

  return <Layout>{children}</Layout>;
};

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredPage="dashboard">
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute requiredPage="users">
              <Users />
            </ProtectedRoute>
          }
        />

        <Route
          path="/loans"
          element={
            <ProtectedRoute requiredPage="loans">
              <Loans />
            </ProtectedRoute>
          }
        />

        <Route
          path="/loan-fee-receipt"
          element={
            <ProtectedRoute requiredPage="loan-fee-receipt">
              <LoanFeeReceipt />
            </ProtectedRoute>
          }
        />
        <Route
          path="/loan-reservations"
          element={
            <ProtectedRoute requiredPage="loan-reservations">
              <LoanReservations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/loan-payments"
          element={
            <ProtectedRoute requiredPage="loan-payments">
              <LoanPayments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/loan-history"
          element={
            <ProtectedRoute requiredPage="loan-history">
              <LoanHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/installments"
          element={
            <ProtectedRoute requiredPage="installments">
              <Installments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenses"
          element={
            <ProtectedRoute requiredPage="expenses">
              <Expenses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/investments"
          element={
            <ProtectedRoute requiredPage="investments">
              <Investments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/weekly-penalties"
          element={
            <ProtectedRoute requiredPage="weekly-penalties">
              <WeeklyPenalties />
            </ProtectedRoute>
          }
        />
        <Route
          path="/balance"
          element={
            <ProtectedRoute requiredPage="balance">
              <Balance />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}
